// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__X06Vx","dialogHeader":"styles_dialogHeader__ds_Lj","link":"styles_link__21GXy"};